import PhoneVerify from "./PhoneVerify";
import "./PhoneVerify.css";

export default PhoneVerify;